/**
 * @file 任务创建-报名任务
 */

import { Modal } from '@seiue/ui'

import { EditTaskProps } from '../types'

import { EditEnrollTaskModal } from './EditEnrollTaskModal'

/**
 * 打开编辑报名任务弹窗
 *
 * @param param0 - 参数
 * @param param0.taskId - 任务 ID
 * @param param0.activityId - 活动 ID
 * @param param0.activityTaskOptions - 活动选项
 */
export const openEditEnrollTask = ({
  activityId,
  taskId,
  activityTaskOptions,
}: EditTaskProps) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <EditEnrollTaskModal
        onClose={() => {
          hide()
        }}
        taskId={taskId}
        activityId={activityId}
        activityTaskOptions={activityTaskOptions}
      />
    ),
  })
}
